import {
  GET_PRODUCTS_SERVICES,
  GET_PRODUCTS_SERVICES_ERROR,
  GET_PRODUCTS_SERVICES_SUCCESS
} from './ContingenciesProductsServicesSection.actions'

const contingenciesProductsServicesState = {
  category: null,
  csv: [],
  data: [],
  error: null,
  family: null,
  loading: false,
  type: 'segments'
}

/**
 * The contingenciesProductsServices's reducer.
 */
const contingenciesProductsServicesReducer = (state = contingenciesProductsServicesState, { payload, type }) => {
  switch (type) {
    case GET_PRODUCTS_SERVICES: {
      return { ...state, data: [], loading: true }
    }
    case GET_PRODUCTS_SERVICES_ERROR: {
      return { ...state, error: payload.error, loading: false }
    }
    case GET_PRODUCTS_SERVICES_SUCCESS: {
      return { ...state, ...payload, loading: false }
    }
    default: {
      return state
    }
  }
}

export default contingenciesProductsServicesReducer
